/* eslint-disable */
import { useMemo } from "react";
import { useDictionary, useOLAPTransformer, OLAPTransformerResult, OLAPTransformerOptions } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Dictionary } from "@sa/rep-mdm";
import { OLAPResult } from "@sa/rep-olap";
import { SLIDE_NUMBER } from "../constants";

const ROW_AXIS = "commodities.default";
const UNIT_AXIS = "units.default";
const COLUMN_AXIS = "calendar.default";

export function useChartData(olapResult: OLAPResult | null): OLAPTransformerResult | null {
  const [, columnsDict] = useDictionary(dictionaryService, "calendar-origin");
  const [itemsRows, rowsDict] = useDictionary(dictionaryService, "slides-commodities");
  const [, unitsDict] = useDictionary(dictionaryService, "slides-units");
  const [itemsRowsDisplay] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    'slide': SLIDE_NUMBER,
    'business_unit': 1
  });

  const options = useMemo<OLAPTransformerOptions | null>(() => {
    if ([olapResult, columnsDict, rowsDict, itemsRows, itemsRowsDisplay].some(x => !Boolean(x))) {
      return null;
    }

    return {
      data: olapResult?.data,
      attrsNameProxy: new Map([
        [`${ROW_AXIS}.name`, (id: unknown, lcid: number) => {
          const itemDisplay = itemsRowsDisplay?.find(x => Number(x.getValue('olap_commodity')) === Number(id));
          const item = itemsRows?.find(x => Number(x.id) === Number(id));
          return (itemDisplay || item)?.getValue('name') || { [lcid]: '' };
        }]
      ]),
      attrsDictionaries: new Map([
        [COLUMN_AXIS, columnsDict],
        [ROW_AXIS, rowsDict],
        [UNIT_AXIS, unitsDict],
      ]) as ReadonlyMap<string, Dictionary>
    } as OLAPTransformerOptions
  }, [olapResult, columnsDict, rowsDict, itemsRows, itemsRowsDisplay]);

  const query = useMemo(() => {
    return {
      lcid: 9,
      columns: [`${COLUMN_AXIS}.name`, `${COLUMN_AXIS}.id`],
      rows: [`${ROW_AXIS}.name`, `${ROW_AXIS}.id`, `${UNIT_AXIS}.name`, `${UNIT_AXIS}.id`],
      cellData: {
        inCell: ["Measures.value"],
        attributes: [`${COLUMN_AXIS}.name`, `${ROW_AXIS}.name`, `${COLUMN_AXIS}.id`, `${ROW_AXIS}.id`],
      },
    }
  }, []);
  const data = useOLAPTransformer(options, query);
  return data;
}
